class DyeforFreeshippingBar extends HTMLElement{
    constructor(){
        super();
    }

    thresholdData=[
        {country:"GB", cartTotal:30, flag:"gb.svg", countyrName: ""},
        {country:"AU", cartTotal:50, flag:"au.svg", countyrName: "Australia"},
        {country:"AT", cartTotal:35, flag:"at.svg", countyrName: "Austria"},
        {country:"CA", cartTotal:45, flag:"ca.svg", countyrName: "Canada"},
        {country:"FR", cartTotal:35, flag:"fr.svg", countyrName: "France"},
        {country:"DE", cartTotal:35, flag:"de.svg", countyrName: "Germany"},
        {country:"IE", cartTotal:35, flag:"ie.svg", countyrName: "Ireland"},
        {country:"IT", cartTotal:35, flag:"it.svg", countyrName: "Italy"},
        {country:"NL", cartTotal:35, flag:"nl.svg", countyrName: "Netherlands"}
    ];
    connectedCallback(){
        setTimeout(() => {
            this.init();            
        });        
    }

    init(){

    }

    hide(){
        this.classList.add('hidden');
    }



    setCartTotal(cartTotal){
        let moneyFormat = this.getAttribute('data-money-format')||"";
        let country = this.getAttribute('data-selected-country')||"GB";
        let data = this.thresholdData.find(x=> x.country === country) || this.thresholdData[0];
        let freeShippingThreshold = data.cartTotal;
        let message = "";
        if(cartTotal === 0){
            let priceString = Shopify.formatMoney(freeShippingThreshold * 100, moneyFormat)
            if(data.countyrName){
                message = `Free shipping to ${data.countyrName} on orders over ${priceString}`;
            }else{
                message = `Free shipping on orders over ${priceString}`;
            }
          }else if(cartTotal < freeShippingThreshold){
            let priceString = Shopify.formatMoney((freeShippingThreshold - cartTotal) * 100, moneyFormat)
            if(data.countyrName){
                message = `You’re only ${priceString} away from free shipping to ${data.countyrName}`;
            }else{
                message = `You’re only ${priceString} away from free shipping`;
            }
          }else{
            message = `You’ve unlocked free shipping`;
          }
          let ps = cartTotal * 100 / freeShippingThreshold;
          if(ps > 100){
              ps = 100;
          }
          
              
          this.setValues(message, ps);
          
    }
    setValues(message, percentage){
        const messageElement = this.querySelector('.free-shipping-message-text') || this.querySelector('.free-shipping-message');
        messageElement.textContent = message;
        this.querySelector('.free-shipping-bar').style.width = `${percentage}%`;
    }
}
window.customElements.define('dyefor-freeshipping-bar', DyeforFreeshippingBar);


    (function(ns, fetch) {
    if (typeof fetch !== 'function') return;
    ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
            if ([
                    `${window.location.origin}/cart/add.js`,
                    `${window.location.origin}/cart/update.js`,
                    `${window.location.origin}/cart/change.js`,
                    `${window.location.origin}/cart/clear.js`,
                    `${window.location.origin}/cart.json`,
		            `${window.location.origin}/cart/add`,
                    `${window.location.origin}/cart/update`,
                    `${window.location.origin}/cart/change`,
                    `${window.location.origin}/cart/clear`,
                ].includes(res.url)) {
                res.clone().json().then(data => handleCartData(data));
            }
        }).catch(() => {});
        return response;
    }

    function handleCartData(data){
        let freeShippingThreshold = 30;
        if(typeof data.items === 'undefined' || typeof data.total_price === 'undefined'){
            fetch("/cart.json").then((data)=>data.json()).then((data)=>handleCartData(data))
            return;
        }
        try{

            if ((typeof productType !== 'undefined' && (productType === 'greetingscard')) || data.items.some(i => i.product_type === 'greetingscard')){
            document.querySelectorAll('dyefor-freeshipping-bar').forEach(i=>{
                i.hide();
            });  
            return;
        }
        }catch(e){
            console.error(e); console.log(data);
        }

        let message = "";
        let carTotal = 0 ;
        try{
        let items = data.items.filter(i =>
            i.product_type !== 'Suitcase' &&
            i.product_type !== 'Cart Add-on' &&
            i.handle !== 'dyefor-shipping-protection'
        );
        carTotal = items.reduce((a,i)=> a + i.final_line_price, 0)/100;
        }catch(e){
        console.error(e); console.log(data);
        }
        
        // if(carTotal === 0){
        //   message = `🚚 Free shipping on orders over £${freeShippingThreshold.toFixed(2)}!`;
        // }else if(carTotal < freeShippingThreshold){
        //   message = `🚚 You’re only £${(freeShippingThreshold - carTotal).toFixed(2)} away from free shipping!`;
        // }else{
        //   message = `🚚 Congratulations! You’ve got free shipping!`;
        // }
        // let ps = carTotal * 100 / freeShippingThreshold;
        // if(ps > 100){
        //     ps = 100;
        // }

        setTimeout(()=>{
            document.querySelectorAll('dyefor-freeshipping-bar').forEach(i=>{
                //i.setValues(message, ps);
                i.setCartTotal(carTotal);
            });
        }, 300);
    }

     setTimeout(async function(){
      await fetch("/cart.json").then((data)=>data.json()).then((data)=>handleCartData(data));
      }, 300); 
}(window, window.fetch))
